import "./index.js";
import "./App.css";
import "./Styles/Common.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./JS/Connector.js";
import "./JS/Common.js";
import { BrowserRouter as Router } from "react-router-dom";
import { useState, createContext, useEffect, useReducer, useLayoutEffect } from "react";
import { ApiGetCallAuthKey, setTenantFlag } from "./JS/Connector.js";
import { Sidemenu } from "./Components/Sidemenu.jsx";
import { origin, RemoveAllCookies, setDccModuleText, setDecimalRange, setGradeDepartment, setParentGuardianManager, setParentManager, setSchoolName, setStudentUser } from "./JS/Common.js";
import { GoogleOAuthProvider } from "@react-oauth/google";
import GlobalStyles from "./Components/GlobalStyles.jsx";
import UnauthenticatedRoutes from "./Layout/Routers/UnauthenticatedRoutes.jsx";
import MatchingPath, { pathsToMatch } from "./Layout/Routers/MatchingPath.jsx";
import CustomAccesses from "./Layout/Routers/CustomAccesses.jsx";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { UserInitialState, UserReducer } from "./Components/UserReducer.jsx";
import { log } from "./JS/Logger.js";
import { useSelector } from "react-redux";
import { store } from "./Store/Store.js";
import { useDispatch } from "react-redux";
import { setSchoolId, setSchoolnumber, setUserTimeZone, setIsEnterprise, setIsDev } from "./Store/Slices/authSlice.js";
import ScrollToTop from "./Components/ScrollToTop.jsx";
import { initSuggestionKeyboardNavigation } from "./JS/SuggestionKeyboardNavigation.js";
export const UserContext = createContext();
export const ThemeContext = createContext();

function App() {
  const config = useSelector(state => state.config.data);
  const stateRedux = store.getState();
  var CsvUserId = stateRedux.authData.csvUserID;
  const clientId = process.env.REACT_APP_GoogleClientId;

  const [menuData, setMenuData] = useState([]);
  const [UserData, setUserData] = useState({
    emailid: "",
    UserName: "",
    MenuAccessFlag: "",
    inventoryflag: "",
    ssoFlag: "",
    InsurancePolicy: "",
    sendOutForRepairFlag: "",
    signatureFlag: "",
    helpdeskflag: "",
    helpdeskUpdatedFlag: "",
    copyaccesstype: "",
    repairflag: "",
    schoollogo: null,
    schoolname: "",
    PaymentLink: "",
    PaymentLinkFlag: "",
    iiqSetUp: 0,
    iiqTag: '',
    oneTimeSyncHubSpot: false,
    SchoolAdminUserFlag: null,
    role: null,
    copyrole: null,
    tempSchoolId: null,
    schoolImpExpFlag: null,
    adminImpExpFlag: null,
    defaultShipMethod: 0
  });
  const pathname = window.location.pathname;
  const pathArray = pathname.split("/");
  const path = pathArray[1];
  const [state, dispatch] = useReducer(UserReducer, UserInitialState);
  const rootTheme = config?.theme
  const dccTheme = rootTheme?.dcc
  const reduxDispatch = useDispatch();
  function setRootStyle(property, value) {
    if (!value) return;
    document.documentElement.style.setProperty(property, value);
  }
  useLayoutEffect(() => {
    if (config) {
      setRootStyle("--primary-color", rootTheme?.primary_color);
      setRootStyle("--secondary-color", rootTheme?.secondary_color);
      setRootStyle("--error_text_color", rootTheme?.error_text_color);
      setRootStyle("--succes_text_color", rootTheme?.succes_text_color);
      setRootStyle("--inProgress_text_color", rootTheme?.inProgress_text_color);
      setRootStyle("--overide_text_danger", rootTheme?.overide_text_danger);
      setRootStyle("--newly_added_color", dccTheme?.newly_added_color);
      setRootStyle("--pending_color", dccTheme?.pending_color);
      setRootStyle("--live_color", dccTheme?.live_color);
      setRootStyle("--past_color", dccTheme?.past_color);
      setRootStyle("--inNegotiation_color", dccTheme?.inNegotiation_color);
      setRootStyle("--rejected_color", dccTheme?.rejected_color);
      setRootStyle("--live_unenroll_color", dccTheme?.live_unenroll_color);
      setRootStyle("--dashboard_dynamic_color", rootTheme?.dashboard_account_registered_color);
      setRootStyle("--paid_color", rootTheme?.paid_color);
      setRootStyle("--unpaid_color", rootTheme?.unpaid_color);
      setRootStyle("--selection_carrier_card", rootTheme?.selection_carrier_card)

      dispatch({
        type: "UPDATE",
        payload: { Login: config?.flags?.origin_flag },
      });
      if (config?.flags?.origin_flag) {
        setTenantFlag(config?.flags?.origin_flag);
      }
      if (config?.terminology?.school) {
        setSchoolName(config?.terminology?.school);
      }
      if (config?.labels?.small_student) {
        setStudentUser(config?.labels?.small_student);
      }
      if (config?.labels?.parent_with_guardian) {
        setParentGuardianManager(config?.labels?.parent_with_guardian);
      }
      if (config?.labels?.parent) {
        setParentManager(config?.labels?.parent);
      }
      if (config?.terminology?.grade) {
        setGradeDepartment(config?.terminology?.grade);
      }
      if (config?.labels?.dcc_module_text) {
        setDccModuleText(config?.labels?.dcc_module_text);
      }
      if (config?.payload?.decimalRange) {
        setDecimalRange(config?.payload?.decimalRange);
      }
    }
  }, [config]);

  useEffect(() => {
    if (config?.flags?.origin_flag) {
      setTenantFlag(config.flags.origin_flag);
    }
    if (config?.flags?.hasOwnProperty('is_enterprise')) {
      reduxDispatch(setIsEnterprise(config.flags.is_enterprise));
    }
    if (config?.labels?.hasOwnProperty('react_app_instance')) {
      reduxDispatch(setIsDev(config.labels.react_app_instance == 'dev' ? true : false));
    }
    
    // Initialize global keyboard navigation for suggestion boxes
    initSuggestionKeyboardNavigation();
  }, []);

  useEffect(() => {
    if (path != "k12logout" && !pathsToMatch.includes(path)) {
      if (CsvUserId != null) {
        setTimeout(() => {
          getMenudata();
        }, 1500);
      }
    }
  }, [CsvUserId]);

  useLayoutEffect(() => {
    const title = config?.brand?.title;
    const faviconUrl = config?.brand?.favicon;

    document.title = title || "";

    if (faviconUrl) {
      let link = document.querySelector("link[rel~='icon']");

      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }

      link.href = faviconUrl;
    }
  }, [config]);

  const getMenudata = async () => {
    try {
      await ApiGetCallAuthKey(
        `/auth/menu-access?userId=${stateRedux.authData.csvUserID}`
      ).then((result) => {
        if (!result) {
          throw new Error("Empty response");
        } else {
          const responseRs = JSON.parse(result);
          if (responseRs?.status == "success") {
            if (responseRs?.msg.length != 0) {
              setMenuData(responseRs?.msg);

              const effectiveRole = responseRs?.user?.temp_access_type || responseRs?.accesstype || null;

              let filteredMsg = responseRs?.msg;
              if (effectiveRole === 'k12_repair_tech' || effectiveRole === 'k12_lead_tech') {
                filteredMsg = responseRs?.msg?.filter(item =>
                  item.school_admin_flag == (responseRs?.user?.temp_access_type ? 2 : 1)
                );
              }

              const SchoolImpExpFlag = filteredMsg?.find(item => item.href == "import-export")?.school_admin_flag;
              const AdminImpExpFlag = filteredMsg?.find(item => item.name == "Configurations")?.submenu?.find(subItem => subItem.href == "import-export")?.school_admin_flag;

              setUserData({
                ...UserData,
                emailid: responseRs?.user?.email,
                UserName:
                  responseRs?.user?.first_name +
                  " " +
                  responseRs?.user?.last_name || "",
                MenuAccessFlag: responseRs?.user?.access_type,
                inventoryflag: responseRs?.inventoryflag,
                ssoFlag: responseRs?.sso_flag,
                InsurancePolicy: responseRs?.user?.school?.insurance_policy,
                sendOutForRepairFlag: responseRs?.default_ticket_staus,
                defaultShipMethod: responseRs?.default_shipping_type,
                signatureFlag: responseRs?.signature_flag,
                helpdeskflag: responseRs?.helpdeskflag,
                helpdeskUpdatedFlag: responseRs?.helpdesk_updated_at,
                copyaccesstype: responseRs?.user?.temp_access_type,
                repairflag: responseRs?.uncovered_repair_charges,
                schoollogo: responseRs?.logo || "",
                schoolname: responseRs?.user?.school?.name,
                PaymentLink: responseRs?.default_payment_link,
                PaymentLinkFlag: responseRs?.payment_link_flag,
                iiqSetUp: responseRs?.iiq_set_up,
                iiqTag: responseRs?.iiq_tag,
                oneTimeSyncHubSpot: responseRs?.one_time_sync_hub_spot,
                SchoolAdminUserFlag: responseRs?.flag,
                role: responseRs?.accesstype || null,
                copyrole: responseRs?.user?.temp_access_type || null,
                oauthClientAccess: responseRs.user.oauth_client_access,
                tempSchoolId: responseRs?.user?.temp_school_id,
                schoolImpExpFlag: SchoolImpExpFlag,
                adminImpExpFlag: AdminImpExpFlag
              });
            }

            reduxDispatch(setSchoolId(responseRs?.user?.school_id));
            dispatch({
              type: "UPDATE",
              payload: {
                ShippingType: responseRs?.user?.school?.shipping_type,
              },
            });
            reduxDispatch(setUserTimeZone(responseRs?.user_time_zone || "America/New_York"));
            reduxDispatch(setSchoolnumber(responseRs?.user?.school_num));
          } else {
            RemoveAllCookies();
            window.location.href = "/";
          }
        }
      });
    } catch (error) {
      log.error(error);
      RemoveAllCookies();
      window.location.href = "/";
    }
  };
  const msalInstance = new PublicClientApplication({
    auth: {
      clientId: process.env.REACT_APP_MicrosoftClientId,
      authority: "https://login.microsoftonline.com/common",
      redirectUri: `${origin}/`,
    },
  });
  return (
    <ThemeContext.Provider value={{ state, dispatch }}>
      <GoogleOAuthProvider clientId={clientId}>
        <MsalProvider instance={msalInstance}>
          <GlobalStyles />
          <Router>
            <ScrollToTop />
            {pathsToMatch.includes(path) ? (
              <MatchingPath path={pathArray[1]} />
            ) : CsvUserId != null ? (
              <UserContext.Provider
                value={{ menuData, UserData, setUserData }}
              >
                <Sidemenu>
                  <CustomAccesses />
                </Sidemenu>
              </UserContext.Provider>
            ) : (
              <UnauthenticatedRoutes />
            )}
          </Router>
        </MsalProvider>
      </GoogleOAuthProvider>
    </ThemeContext.Provider>
  );
}

export default App;